"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPredominantSpeciesByKey = exports.predominant_species_map = exports.predominant_species_list = exports.predominant_species = void 0;
const util_1 = require("./util");
exports.predominant_species = [
    {
        key: 'acacias',
        tupuake_id: 1,
        display_name: 'Acacias',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'beeches',
        tupuake_id: 2,
        display_name: 'Beeches',
        ets_species_key: 'indigenous',
    },
    {
        key: 'beeches__oaks',
        tupuake_id: 3,
        display_name: 'Beeches/oaks',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'broadleaved_species',
        tupuake_id: 4,
        display_name: 'Broadleaved Species',
        ets_species_key: 'indigenous',
    },
    {
        key: 'cedars__firs__larches__spruces__hemlocks',
        tupuake_id: 5,
        display_name: 'Cedars/firs/larches/spruces/hemlocks',
        ets_species_key: 'exotic_softwood',
    },
    {
        key: 'coprosmas',
        tupuake_id: 6,
        display_name: 'Coprosmas',
        ets_species_key: 'indigenous',
    },
    {
        key: 'cypresses',
        tupuake_id: 7,
        display_name: 'Cypresses',
        ets_species_key: 'exotic_softwood',
    },
    {
        key: 'douglas_fir',
        tupuake_id: 8,
        display_name: 'Douglas Fir',
        ets_species_key: 'douglas_fir',
    },
    {
        key: 'eucalypts',
        tupuake_id: 9,
        display_name: 'Eucalypts',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'fruit_and_nut',
        tupuake_id: 10,
        display_name: 'Fruit and Nut',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'hawthorn',
        tupuake_id: 24,
        display_name: 'Hawthorn',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'indigenous',
        tupuake_id: 22,
        display_name: 'Indigenous',
        ets_species_key: 'indigenous',
    },
    {
        key: 'japanese_spindle_tree',
        tupuake_id: 25,
        display_name: 'Japanese spindle tree',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'manuka__kanuka',
        tupuake_id: 11,
        display_name: 'Manuka/Kanuka',
        ets_species_key: 'indigenous',
    },
    {
        key: 'maples__birches__alders',
        tupuake_id: 12,
        display_name: 'Maples/birches/alders',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'pines',
        tupuake_id: 14,
        display_name: 'Pines',
        ets_species_key: 'exotic_softwood',
    },
    {
        key: 'pinus_radiata',
        tupuake_id: 15,
        display_name: 'Pinus Radiata',
        ets_species_key: 'pinus_radiata',
    },
    {
        key: 'pittosporums',
        tupuake_id: 16,
        display_name: 'Pittosporums',
        ets_species_key: 'indigenous',
    },
    {
        key: 'podocarps',
        tupuake_id: 17,
        display_name: 'Podocarps',
        ets_species_key: 'indigenous',
    },
    {
        key: 'poplars__aspens__paulownia__catalpa',
        tupuake_id: 18,
        display_name: 'Poplars/aspens/paulownia/catalpa',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'redwood',
        tupuake_id: 26,
        display_name: 'Redwood',
        ets_species_key: 'exotic_softwood',
    },
    {
        key: 'rowan__mountain_ash__ash',
        tupuake_id: 27,
        display_name: 'Rowan/Mountain Ash/Ash',
        ets_species_key: 'exotic_hardwood',
    },
    {
        key: 'tree_ferns',
        tupuake_id: 19,
        display_name: 'Tree Ferns',
        ets_species_key: 'indigenous',
    },
    {
        key: 'willows',
        tupuake_id: 20,
        display_name: 'Willows',
        ets_species_key: 'exotic_hardwood',
    },
];
exports.predominant_species_list = exports.predominant_species.map((sp) => sp.key);
exports.predominant_species_map = (0, util_1.toMap)(exports.predominant_species);
const getPredominantSpeciesByKey = (species) => exports.predominant_species_map[species];
exports.getPredominantSpeciesByKey = getPredominantSpeciesByKey;
